let storeContent = utils.generateStore({
	kyc_fields: [],
	kyc_docs: [],
	kyc_images: [],
	kyc_details: {},
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchKYC(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'kyc',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('kyc_details', res.result);

				if (res.result.client_kyc) {
					let fields = [];

					for (const [key, val] of Object.entries(
						res.result.client_kyc.client_details,
					)) {
						fields.push({ key, val });
					}

					console.log('kyc details', res.result);
					console.log('fields', fields);
					ctx.commit('kyc_fields', fields);
					ctx.commit(
						'kyc_docs',
						res.result.client_kyc.client_documents,
					);
					ctx.commit(
						'kyc_images',
						res.result.client_kyc.client_images,
					);
				}
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
	},
};
